import { DesignAction, DesignEvent, IPageAction } from "../../../base/models";
import React, { useEffect, useState } from "react";

import { Binding } from "../../../base/bindings";
import { IDataSource } from "../../../base/types";
import { PropertyBindings } from "../../page-control/property-panel/PropertyBindings";
import { SelectMaterialIcon } from "../../widgets";
import { useGetActionProperties } from "./useGetActionProperties";

export const ActionProperties = ({ action, dataSource, onDesignChange }: {
    action: IPageAction,
    dataSource?: IDataSource,
    onDesignChange: (event: DesignEvent) => void
}) => {
    const [localAction, setLocalAction] = useState<IPageAction>(action)
    const { getProperties, properties } = useGetActionProperties();

    useEffect(() => {
        setLocalAction(action)
        // eslint-disable-next-line
    }, [action])

    useEffect(() => {
        getProperties(localAction.type)
        // eslint-disable-next-line
    }, [localAction])

    useEffect(() => {
        onDesignChange({ type: DesignAction.UpdateAction, action: localAction })
        // eslint-disable-next-line
    }, [localAction])

    const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setLocalAction({ ...localAction, name: e.target.value })
    }

    const onBindingsChange = (bindings: Binding[]) => {
        setLocalAction({ ...localAction, bindings: bindings })
    }

    const onIconChange = (value?: string) => {
        setLocalAction({ ...localAction, icon: value })
    }

    return (
        <div className="card border-0 rounded-0 h-100">
            <div className="card-header min-h-5px border-0 px-5 mb-10">
                <h6 className="mt-5 mb-1">
                    <span>Properties</span>
                    <span className="badge badge-primary fw-semibold ms-3">
                        {localAction.type}
                    </span>
                </h6>
            </div>
            <div className="card-body p-5 pt-2 overflow-auto">
                <div className="mb-2">
                    <label className="fs-8 fw-bold text-gray-600">Action Name</label>
                    <input type="text"
                        className="form-control form-control-xs"
                        onChange={onNameChange}
                        value={localAction.name} />
                </div>

                <SelectMaterialIcon
                    title="Icon"
                    className="mb-2"
                    value={localAction.icon}
                    onChange={onIconChange} />

                <PropertyBindings
                    bindings={localAction.bindings}
                    properties={properties || []}
                    dataSource={dataSource}
                    onChange={onBindingsChange} />
            </div>
        </div>
    )
}
